// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"279":"ed484142","358":"0c61088a","915":"5754da3d"}[chunkId] + ".css";
};